import React from 'react';
import { Phone, Clock, ArrowUpRight } from 'lucide-react';
import { useDrawers } from '../../contexts/DrawerContext';
export function UrgencyBar() {
  const {
    openUpload
  } = useDrawers();
  return <div className="bg-ink text-cream text-sm" data-id="element-398" data-mp="26kjym7souevr">
      <div className="max-w-7xl mx-auto px-5 md:px-6 py-2.5 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-1.5 sm:gap-4 text-center" data-id="element-399" data-mp="26lcv8fxxno06">
        <p className="flex items-center gap-2 text-cream/85" data-id="element-400" data-mp="2z8piksbx3zuj">
          <Clock className="w-4 h-4 text-peach shrink-0" data-id="element-401" data-mp="2uanyq56o3wi0" />
          Auction or signing deadline coming up? Add the date to your enquiry
          and the team will assess the urgency.
        </p>
        <div className="flex items-center gap-4 shrink-0" data-id="element-402" data-mp="2l9znfi8nsa8t">
          <a href="tel:+61386172600" className="hidden sm:flex items-center gap-1.5 font-semibold hover:text-peach transition-colors" data-id="element-403" data-mp="2l9g1lqfw11pi">
            <Phone className="w-3.5 h-3.5" data-id="element-404" data-mp="19uko47sz96aj" />
            (03) 8617 2600
          </a>
          <button onClick={openUpload} className="inline-flex items-center gap-1 font-semibold text-peach hover:text-white transition-colors" data-id="element-405" data-mp="1nu7vxl6v2fwu">
            Upload a contract
            <ArrowUpRight className="w-3.5 h-3.5" data-id="element-406" data-mp="1eut6mp2fkbdx" />
          </button>
        </div>
      </div>
    </div>;
}